import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { BookOpen, ShieldCheck, FileText, CalendarCheck } from 'lucide-react';
export function WhatYouGet() {
  const features = [{
    icon: <BookOpen className="w-8 h-8 text-brand-cyan" data-id="element-211" />,
    title: 'La Guía Maestra Crédito Maestro 2026',
    desc: 'El paso a paso detallado para auditar tu propio reporte sin perderte en jerga legal.'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-brand-cyan" data-id="element-212" />,
    title: 'El Protocolo de Borrado de Identidad',
    desc: "Cómo eliminar direcciones viejas que 'amarran' las deudas negativas a tu perfil."
  }, {
    icon: <FileText className="w-8 h-8 text-brand-cyan" data-id="element-213" />,
    title: 'Las 5 Cartas de Oro',
    desc: 'Plantillas listas para copiar y enviar que el software e-OSCAR no puede rechazar.'
  }, {
    icon: <CalendarCheck className="w-8 h-8 text-brand-cyan" data-id="element-214" />,
    title: 'Lista de Verificación de 30 Días',
    desc: 'Para que sepas exactamente qué hacer cada semana y no pierdas el ritmo.'
  }];
  return <SectionWrapper className="bg-brand-darker" data-id="element-215">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-216">
        <div className="text-center mb-16" data-id="element-217">
          <h2 className="text-4xl md:text-5xl font-display uppercase mb-4" data-id="element-218">
            Lo que obtienes hoy
          </h2>
          <div className="w-24 h-1 bg-brand-cyan mx-auto rounded-full" data-id="element-219"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-220">
          {features.map((feature, idx) => <div key={idx} className="bg-brand-card border border-gray-800 p-8 rounded-2xl flex flex-col sm:flex-row gap-6 items-start hover:border-brand-cyan/50 transition-colors" data-id="element-221">
              <div className="bg-brand-cyan/10 p-4 rounded-xl shrink-0" data-id="element-222">
                {feature.icon}
              </div>
              <div data-id="element-223">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-224">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-225">{feature.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}